<div class="action-container">
  <div class="alert-action-wrapper">
    <app-ag-action-icon-button
      [iconClass]="alertIconClass"
      [numberOfAlerts]="numberOfNewAlerts"
      [disabled]="!numberOfAlerts"
      (action)="numberOfAlerts && onOpenAlerts()"
    />
  </div>

  <app-ag-action-icon-button
    iconClass="ic-notes-16"
    (action)="onOpenNotes()"
    *appHasRole="['Admin', 'Manager', 'Preparer']"
  />

  <app-ag-action-icon-button
    iconClass="ic-eye-16"
    (action)="onOpenProfile()"
    *appHasRole="['Admin', 'Manager', 'Preparer']"
  />
</div>
